'use strict';

var Joi = require('joi');
var experimentsSchema_model = require('../utils/experimentsSchema.model.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var SignupUserUpdate = Joi__default["default"].object().keys({
  content_categories: Joi__default["default"].array().items(Joi__default["default"].string()).required().min(0).description('Creators content categories selections'),
  twitter_handle: Joi__default["default"].string().allow(null).default(null).description('Creators Twitter Handle'),
  experiments: experimentsSchema_model,
  name: Joi__default["default"].string().optional().description('Creator Name'),
  username: Joi__default["default"].string().optional().description('Creator Username'),
  page_number: Joi__default["default"].number().min(1).required().description('Step in Onboarding Wizard')
}).description('This fires when when a user updates attributes such as content_categories and twitter_handle.').meta({
  name: 'SignupUserUpdate',
  filename: 'signup:user_update.model'
});
var SignupUserUpdate$1 = SignupUserUpdate;

module.exports = SignupUserUpdate$1;
//# sourceMappingURL=user_update.model.js.map
